import './App.css';
import { useEffect, useState, JSX } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import HomePage, { homePageButton } from './home-page/homePage';
import AddPage from './add-page/addPage';
import TodoSummaryAnimation from './animation/summaryAnimation';
import TodoManager from './todolist/data/todoManager';
import TodoPage from './todo-page/todoPage';
import NotePage from './note-page/note-page';
import PreviewPage from './preview-page/previewPage';
import LoginPage from './auth/LoginPage';
import ProtectedRoute from './auth/ProtectedRoute';
import CalendarPage from './calendar-page/calendarPage';
import GoogleAuthCallback from './services/googleAuthCallback'
import LogoutPage from './auth/LogoutPage'

function MainApp() {
  const [menuButton, setMenuButton] = useState<homePageButton>(null);
  const [openPage, setOpenPage] = useState<JSX.Element>(<></>);
  const [isLoaded, setIsLoaded] = useState(true);
  const [isOpenPage, setIsOpenPage] = useState(false);

  const setLoad = () => {
    setTimeout(() => {
      setIsLoaded(true);
    }, 2000);  // 2000ms = 2 seconds
  };

  useEffect(() => {
    if(menuButton === 'Add')
      setOpenPage(<AddPage setClosePage={handlePageClose} />);
    else if(menuButton === 'Note')
      setOpenPage(<NotePage setClosePage={handlePageClose}/>);
    if(menuButton === 'Todo')
      setOpenPage(<TodoPage setClosePage={handlePageClose}/>);
    else if(menuButton === 'Calendar')
      setOpenPage(<CalendarPage setClosePage={handlePageClose}/>);
    else if(menuButton === null)
      setOpenPage(<></>);
  },[menuButton]);

  useEffect(() => {
    if (menuButton != null && openPage != <></>)
      setIsOpenPage(true);
    else
    setIsOpenPage(false);
  }, [menuButton])

  const handlePageClose = () => {
    setOpenPage(<></>);
    setMenuButton(null);
  }

  const todoManager = TodoManager.getInstance();

  return (
    <div className={`App ${isLoaded ? 'App--loaded' : ''}`}>
      {isLoaded ? (
        <div>
          <HomePage clickButton={menuButton} onClickButtonChange={setMenuButton}/>
          <div className={isOpenPage? 'main-app-overlay-darken' : 'main-app-overlay'}>
            <div className='overlay-content'>
              {openPage}
            </div>
          </div>
        </div>
      ) : (
        <>
          <TodoSummaryAnimation todos={todoManager.getTodos()} onAnimationComplete={setLoad}/>
        </>
      )}
    </div>
  );
}

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/auth/google/callback" element={<GoogleAuthCallback />} />
        <Route path="/" element={
          <ProtectedRoute>
            <MainApp />
          </ProtectedRoute>
        } />
        <Route path="/preview" element={
          <ProtectedRoute>
            <PreviewPage />
          </ProtectedRoute>
        } />
        {/* Add a catch-all route if needed */}
        {/* <Route path="*" element={<Navigate to="/" replace />} /> */}
        <Route path="/logout" element={<LogoutPage/>} />
      </Routes>
    </Router>
  );
}

export default App;